<!-- Hero Banner starts -->

<div class="container-fluid top-hero-banner-bg">

    <div class="row">
        <div class="col-xl-6 col-lg-6  col-md-12  col-sm-12  col-xs-12   content-panel">

            <div class="lead-content">


                <h1 class="top-hero-banner-heading  text-left">Get Instant Savings on Fast, Reliable Internet & Phone
                    with Comcast Business</h1>
                <h2 class="top-hero-banner-text  text-left">Fastest speeds at lowest prices in your area. </h2>
                <div class="text-left mt-4 " *ngIf="false">
                    <div class="row outline">
                        <div class="col-xl-5 col-lg-5  col-md-6  col-sm-12  col-xs-12 mt-4 mb-4 ">

                            <img class="img-fluid"
                                src="../../../assets/images/home/comcast-business-visa-card-$100.png" />
                        </div>

                        <div class="col-xl-7 col-lg-7  col-md-5 col-sm-12  col-xs-12 mt-4 mb-4 justify">
                            <p class="business-plan-sub-heading mb-0"><strong>GET A $100 VISA<sup>&#174;</sup> PREPAID CARD</strong></p>
                            <p class="banner-sm-text  mb-0">On select bundles with 2-year agreement. Offer ends 8/21/23. Restrictions apply. Not available in all areas. <a class="offer-details-text" (click)="open(mymodal)">Offer details</a></p>
                           
                        </div>
                    </div>
                </div>
                <div class="text-left mt-4 ">

                    <div class="row mt-4 mb-4">
                        <p class="business-plan-sub-heading mb-0">Start here</p>
                        <p class="banner-sub-text  mb-0">What size is your business?</p>

                        <button class="hero-free-quote-btn-sm" [routerLink]="['/lead-flow']"
                            [queryParams]="{tfn: this.tfn, campaignID: campaignID, secondaryLeadSource: secondaryLeadSource }">1-10 Employees</button>
                        <button class="hero-free-quote-btn-sm" [routerLink]="['/lead-flow']"
                            [queryParams]="{tfn: this.tfn, campaignID: campaignID, secondaryLeadSource: secondaryLeadSource }">11-50 Employees</button>
                        <button class="hero-free-quote-btn-sm" [routerLink]="['/lead-flow']"
                            [queryParams]="{tfn: this.tfn, campaignID: campaignID, secondaryLeadSource: secondaryLeadSource }">51+ Employees</button>
                    </div>

                    <div class="service-learn-more-area" [routerLink]="['/contact-us']">
                        <p class="service-learn-more-area-text">
                            Customer Service &#160;&#160; <i class="fas fa-arrow-right"></i>
                        </p>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-xl-6 col-lg-6  col-md-12  col-sm-12  col-xs-12  hero-banner-div-img">
            <img class="img-fluid" src="../../../assets/images/home/comcast-business-savings-hero-1.png" />
        </div>


    </div>



</div>


<!-- Hero Banner end -->




<!-- Popular Comcast Business Plans starts -->

<div class="business-plan-bg">
    <div class="container-fluid">
        <div class="row business-plan-heading-row">
            <div class="col-12 business-plan-heading-div">
                <h3 class="business-plan-heading">Popular Comcast Business Plans</h3>
                <p class="business-plan-sub-heading">Reliable Connectivity to Keep Your Business Ready</p>
            </div>
        </div>
        <div class="row business-plan-tiles-row">
            <div class="col-sm-12 col-md-3 business-plan-tiles-div">
                <img class="business-plans-tiles-img"
                    src="../../../assets/images/home/comcast-business-starter-internet-phone-tv.jpg"
                    alt="Starter Internet + Phone + TV" />
                <div class="business-plans-tiles-div">
                    <h4 class="business-plans-tiles-heading">Starter Internet + Phone + TV</h4>
                    <p class="business-plans-tiles-text">Basic TV - up to 35 channels</p>
                    <p class="business-plans-tiles-text">35/5 Mbps Internet</p>
                    <p class="business-plans-tiles-text">1 Full Featured Phone Line</p>
                </div>
            </div>
            <div class="col-sm-12 col-md-3 business-plan-tiles-div">
                <img class="business-plans-tiles-img"
                    src="../../../assets/images/home/comcast-business-deluxe-internet-phone-tv.jpg"
                    alt="Deluxe Internet + Phone + TV" />
                <div class="business-plans-tiles-div">
                    <h4 class="business-plans-tiles-heading">Deluxe Internet + Phone + TV</h4>
                    <p class="business-plans-tiles-text">Basic TV - up to 35 channels</p>
                    <p class="business-plans-tiles-text">100/15 Mbps Internet</p>
                    <p class="business-plans-tiles-text">2 Full Featured Phone Lines</p>
                    <p class="business-plans-tiles-text">Recommended for 3 or more device users</p>
                </div>
            </div>
            <div class="col-sm-12 col-md-3 business-plan-tiles-div">
                <img class="business-plans-tiles-img"
                    src="../../../assets/images/home/comcast-business-phone-internet.jpg" alt="Phone + Internet" />
                <div class="business-plans-tiles-div">
                    <h4 class="business-plans-tiles-heading">Phone + Internet</h4>
                    <p class="business-plans-tiles-text">35/5 Mbps Internet</p>
                    <p class="business-plans-tiles-text">Ideal for checking emails and business transactions</p>
                    <p class="business-plans-tiles-text">1 Business Phone Line</p>
                    <p class="business-plans-tiles-text">Recommended for 1-2 device users</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Popular Comcast Business Plans ends -->



<!-- Comcast Business Internet starts -->


<div class="row comcast-internet-row">
    <div class="col-sm-12 col-md-6 comcast-internet-text-div">
        <h3 class="comcast-internet-heading">Comcast Business Internet</h3>
        <ul class="comcast-internet-bullets-ul">

            <li class="comcast-internet-bullets-li"><span class="comcast-internet-bullet-text">Internet speeds from 35
                    Mbps up to 1 Gig</span></li>
            <li class="comcast-internet-bullets-li"><span class="comcast-internet-bullet-text">Comcast Business
                    SecurityEdge™: helps protect against malwares, bots, and more by scanning every 10 mins</span></li>
            <li class="comcast-internet-bullets-li"><span class="comcast-internet-bullet-text">4G LTE Backup: When power
                    goes out, stay connected for up to 8hrs</span></li>
        </ul>
        <div class="comcast-internet-free-quote-btn-div">
            <button class="comcast-internet-free-quote-btn" (click)="openModal()">Get Free Quote</button>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 comcast-internet-img-div"></div>
</div>

<!-- Comcast Business Internet ends -->

<!-- Need help starts -->

<div class="need-help-bg">
    <div class="container-fluid">
        <div class="row need-help-row">
            <div class="col-12 need-help-div">
                <h2 class="need-help-heading">Need help finding the right Comcast Business solution?</h2>
                <p class="need-help-text">We’ll recommend solutions for your business and show you some of our best
                    offers available at your location.</p>
                <button class="need-help-quote-btn" (click)="openModal()">Get Free Quote</button>
            </div>
        </div>
    </div>
</div>



<!-- Need help ends -->

<!-- Crystal Clear Calling starts -->

<div class="row crystal-clear-calling-row">
    <div class="col-sm-12 col-md-6 crystal-clear-calling-text-div">
        <h3 class="crystal-clear-calling-heading">Comcast Business Phone Provides Crystal-Clear Calling on Our Advanced
            Network</h3>
        <p class="crystal-clear-calling-text">Comcast Business helps you with high-quality VoIP services that can help
            keep you and your team communicating. Wherever the workday takes you next.</p>
        <div class="crystal-clear-calling-free-quote-btn-div">
            <button class="crystal-clear-calling-free-quote-btn" (click)="openModal()">Get Free Quote</button>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 crystal-clear-calling-img-div"></div>
</div>



<!-- Crystal Clear Calling ends -->

<!-- Next-level Business TV starts -->

<div class="row next-level-business-tv-row">
    <div class="col-sm-12 col-md-6 next-level-business-tv-text-div order-sm-12">
        <h3 class="next-level-business-tv-heading">Comcast Next-level Business TV</h3>
        <p class="next-level-business-tv-text">Give your customers, visitors, and employees live TV, sports, streaming,
            and music in one place. X1 for Business is a complete, entertainment viewing experience.</p>
        <div class="next-level-business-tv-free-quote-btn-div">
            <button class="next-level-business-tv-free-quote-btn" (click)="openModal()">Get Free Quote</button>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 next-level-business-tv-img-div order-sm-1"></div>
</div>



<!-- Next-level Business TV ends -->

<!-- Comcast Bundle starts -->

<div class="row comcast-bundle-row">
    <div class="col-sm-12 col-md-6 comcast-bundle-text-div">
        <h3 class="comcast-bundle-heading">Comcast Business Internet and Phone Bundles that prepare your business for
            the future</h3>
        <ul class="comcast-bundle-bullets-ul">
            <li class="comcast-bundle-bullets-li"><span class="comcast-bundle-bullet-text">Fast, reliable Internet to
                    keep you connected</span></li>
            <li class="comcast-bundle-bullets-li"><span class="comcast-bundle-bullet-text">Flexible pricing to meet your
                    needs</span></li>
            <li class="comcast-bundle-bullets-li"><span class="comcast-bundle-bullet-text">Expert customer support for
                    your
                    business, 24/7</span></li>
        </ul>
        <div class="comcast-bundle-free-quote-btn-div">
            <button class="comcast-bundle-free-quote-btn" (click)="openModal()">Get Free Quote</button>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 comcast-bundle-img-div"></div>
</div>



<!-- Comcast Bundle ends -->


<!-- Bottom Banner starts -->

<div class="hero-banner-bg">
    <div class="container-fluid">
        <div class="row hero-banner-row">
            <div class="col-12 hero-banner-div">
                <h1 class="hero-banner-heading">Comcast Business Services</h1>
                <h2 class="hero-banner-text">Business Internet and Phone Solutions that prepare your business for the
                    future.</h2>
                <button class="hero-free-quote-btn" (click)="openModal()">Get Free Quote</button>
            </div>
        </div>
    </div>
</div>

<!-- Bottom Banner starts -->

<!---disclaimer--->

<div class="row comcast-bundle-row">
    <div class=" comcast-bundle-text-div">
        <p class="disclaimer-text">
            Restrictions apply. Not available in all areas. Services and features vary depending on level of service.
            Comcast Business Internet required for Comcast Business SecurityEdge and Connection Pro. Internet: Actual
            speeds vary and are not guaranteed. SecurityEdge: Does not prevent access to Internet sites if connected via
            public WiFi, Connection Pro, virtual private network technology or non-Comcast DNS servers. Connection Pro:
            Backup time varies depending on the number of connected devices and is not guaranteed.

            <br/>
            <br/>

            <!-- *On select bundles with 2-year agreement. Offer ends 8/21/23. Restrictions apply. Not available in all areas <a class="banner-sm-text " (click)="open(mymodal)">Offer details</a> -->
        </p>
    </div>
</div>


<!---disclaimer--->


<!---popup --->
<ng-template #mymodal let-modal>
    <div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Offer details</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
    <div class="modal-body">
        New Comcast Business customers only. While supplies last. Requires subscription to Eligible Services in a bundled package. Eligible packages may vary by state and region. Early termination fee may apply. Account Holder must subscribe to eligible services by 8/21/2023, install by 9/21/2023, and have services for 30 days post installation.  Card emailed to Comcast Business account holder within 8-10 weeks of satisfying of all required services/requirements and expires in 180 days. Prepaid card can be used anywhere Visa debit card are accepted.
    </div>

</ng-template>

<!---popup --->